import React from 'react';

import { NoData } from './NoData';

export const 未集計: React.FC = () => {
  return <NoData title={'- 未集計 -'} />;
};
